import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/page/Layout'
import Notice from '@/page/subPage/Notice'
import Parts from '@/page/subPage/Parts'
import Contracts from '@/page/subPage/Contracts'
import Issues from '@/page/subPage/Issues'
import Login from '@/page/Login'
import SignRecord from '@/page/subPage/SignRecord.vue'
import LoginRecord from '@/page/subPage/LoginRecord.vue'
import InvoiceUpload from '@/page/subPage/InvoiceUpload.vue'
import Mfgmanager from '../page/subPage/mfgmanager.vue'
import ContractSubSearch from '../page/subPage/ContractSubSearch.vue'
import SignPlan from '../page/subPage/SignPlan.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'hello',
      component: Layout,
      meta: {
        requireAuth: true
      },
      children: [
        {
          path: '/',
          name: 'notice',
          component: Notice,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/notice',
          name: 'notice',
          component: Notice,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/parts',
          name: 'parts',
          component: Parts,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/contracts',
          name: 'contracts',
          component: Contracts,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/issues',
          name: 'issues',
          component: Issues,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/signRecord',
          name: 'signRecord',
          component: SignRecord,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/loginRecord',
          name: 'loginRecord',
          component: LoginRecord,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/invoiceUpload',
          name: 'invoiceUpload',
          component: InvoiceUpload,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/mfgmanager',
          name: 'mfgmanager',
          component: Mfgmanager,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/contractSubSearch',
          name: 'contractSubSearch',
          component: ContractSubSearch,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/signPlan',
          name: 'signPlan',
          component: SignPlan,
          meta: {
            requireAuth: true
          }
        }

      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js